var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEditing)?_c('RefugeProfileEdit',{on:{"finish-edit":_vm.finishEdit}}):_c('RefugeProfileView',{attrs:{"refuge":_vm.$auth.mongoUser},on:{"start-edit":_vm.startEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }